@if (icon || helper || linkText || label) {
  <tidy-row>
    <div [ngClass]="{'important-task-label' : highlightLabel}">
      @if (icon) {
        <tidy-image
          [src]="icon"
          class="text-top-align" />
      }
      <tidy-text
        [body]="label" />
    </div>
    @if (helper) {
      <tidy-text
        [helper]="helper" />
    }
    @if (linkText) {
      <tidy-text
        [body]="' '" />
      <tidy-text
        [body]="linkText"
        class="link"
        (action)="linkAction.emit()" />
    }
  </tidy-row>
}

<mat-radio-group [value]="value" [class.invalid-field]="!form?.valid" [class.chunk-elements]="!!chunkSize && !sameRow" [class.same-row]="!!chunkSize && sameRow">
  @if (!sameRow) {
    @for (itemGroup of itemsInternal; track itemGroup; let i = $index) {
      <div class="group">
        @for (item of itemGroup; track item; let i = $index) {
          <mat-radio-button
            class="radio-button"
            [value]="item?.value"
            (change)="onChange(item)"
            >
            {{item?.viewValue | translate}}
          </mat-radio-button>
        }
      </div>
    }
  }
  @if (sameRow) {
    @for (item of getVisibleItems(); track item; let i = $index) {
      <mat-radio-button
        class="radio-button"
        [value]="item?.value"
        (change)="onChange(item)"
        >
        {{item?.viewValue | translate}}
      </mat-radio-button>
    }
  }
</mat-radio-group>

@if (!showAllItems && hideItemValues?.length) {
  <tidy-row class="field-top-padding">
    <tidy-text
      [body]="'More'"
      (action)="expandOptions()"
      class="link more-text"
    />
  </tidy-row>
}

@if (selectError) {
  <tidy-error-message
    [text]="selectMessage" />
}

@if (errorMessage && submitted && !form.valid) {
  <tidy-error-message
    [text]="errorMessage" />
}
